import React,{ TextareaHTMLAttributes } from "react";

export interface TextareaProps
  extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    error?:string;
  }

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className = "", children, rows = 4, error, ...args }, ref) => {
    return (
      <>
        <textarea
          ref={ref}
          className={`block w-full text-sm rounded-2xl border-neutral-200 focus:border-primary-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50 bg-white dark:border-neutral-700 dark:focus:ring-primary-6000 dark:focus:ring-opacity-25 dark:bg-neutral-900 ${className}`}
          rows={rows}
          {...args}
        >
          {children}
        </textarea>
        {error && <span className="text-red-500 text-sm mt-2">{error}</span>}
      </>
    );
  }
);

export default Textarea;
